module.exports = __webpack_public_path__ + "img/home-gywm1.f5bb5e75.png";